import { Chip } from "@mui/material";
import { UPLOAD_STATES } from "../../store/uploadQueue";

export default function UploadStatus({ state }) {
  const label_color = {
    [UPLOAD_STATES.IDLE]: {
      color: "#00b976",
      label: "READY",
    },
    [UPLOAD_STATES.UPLOADING]: {
      color: "#0288d1",
      label: "IMPORT IN PROGRESS",
    },
    [UPLOAD_STATES.COMPLETE]: {
      color: "#b000f0",
      label: "NORMALIZING",
    },
  };

  const label = label_color[state]?.label;
  const color = label_color[state]?.color;

  return (
    <Chip
      sx={{ backgroundColor: color, color: "white", width: "fit-content" }}
      label={label}
    />
  );
}
